import { useTranslation } from "react-i18next";
import React from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";

const tabsWrap =
  "inline-flex items-center rounded-full bg-gray-100 p-1 ring-1 ring-black/5";
const tabBase =
  "px-4 h-9 rounded-full text-[13px] font-medium leading-none transition " +
  "focus:outline-none focus:ring-2 focus:ring-appleblueD";

const tabCls = (active: boolean) =>
  [
    tabBase,
    active ? "bg-white shadow-sm text-gray-700" : "text-gray-500 hover:text-gray-700",
  ].join(" ");

const pageWrap = "w-full max-w-6xl mx-auto px-2 sm:px-6";

export default function SpendingLayout() {
  const { t } = useTranslation();
  const location = useLocation();

  // Prevent “came back mid-scroll” / wrap-shift weirdness
  React.useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-gray-50 text-[13px] font-normal text-gray-700">
      {/* Header zone (isolated + sticky) */}
      <div className="sticky top-0 z-30 bg-gray-50/90 backdrop-blur">
        <div className={`${pageWrap} pt-4 mb-2`}>
          <div className="flex items-center justify-between gap-3 flex-wrap">
            <div className="text-[15px] font-semibold text-gray-700">{t("navigation.spending")}</div>

            <div className={tabsWrap} aria-label={t("expenses.tabs.aria")}>
              <NavLink end to="expenses" className={({ isActive }) => tabCls(isActive)}>
                {t("expenses.common.expenses")}
              </NavLink>
              <NavLink end to="prepaids" className={({ isActive }) => tabCls(isActive)}>
                {t("expenses.tabs.prepaids")}
              </NavLink>
              <NavLink end to="deposits" className={({ isActive }) => tabCls(isActive)}>
                {t("expenses.tabs.deposits")}
              </NavLink>
              <NavLink to="fixed-assets" className={({ isActive }) => tabCls(isActive)}>
                {t("expenses.tabs.fixedAssets")}
              </NavLink>
            </div>
          </div>
        </div>
        <div className="h-px bg-gray-200/70" />
      </div>

      {/* Content zone */}
      <div className={`${pageWrap} pb-10`}>
        <Outlet key={location.pathname} />
      </div>
    </div>
  );
}
